import React, { Component } from 'react';
import './index.scss';
import Loader from '../../pages/loader';
import * as API from '../../configuration/apiconfig';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';
import { keyboardLayout } from '../../utils/keyBoardLayout';

const buttonTheme = [
  {
    class: 'phone-login-close-button',
    buttons: '{phoneLoginCloseButton}',
  },
  {
    class: 'backspace-button',
    buttons: '{bksp}',
  },
];

export default class EmailLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      layoutName: 'shift',
      loginErrorMsg: '',
      email: '',
      showKeyboard: false,
    };
  }

  keyBoardOnKeyPress = button => {
    // console.log("Button pressed", button);
    if (button === '{shift}' || button === '{lock}') this.keyBoardHandleShift();

    if (button === '{phoneLoginCloseButton}') {
      this.setState({
        showKeyboard: false,
        email: '',
        loginErrorMsg: '',
      });
    }
  };

  keyBoardHandleShift = () => {
    const layoutName = this.state.layoutName;
    this.setState({
      layoutName: layoutName === 'default' ? 'shift' : 'default',
    });
  };

  clickKeyboardIconPhone = () => {
    this.setState(
      {
        showKeyboard: !this.state.showKeyboard ? true : false,
      },
      () => {
        var getInputElem = document.getElementById('emailInput');
        if (getInputElem) {
          document.getElementById('emailInput').focus();
        }
      }
    );
  };

  setKeyboard = () => {
    this.setState({
      showKeyboard: true,
    });
  };

  openKeyboard = () => {
    this.setState({ showKeyboard: true });
  };

  closeKeyboard = () => {
    this.setState({ showKeyboard: false });
  };

  emailChange = email => {
    this.props.emailChange(email);
  };

  render() {
    return (
      <React.Fragment>
        <Loader loader={this.state.loader} />
        <div className={`email-login ${this.props.dynamicComponent ? ' dynamic-component-login' : ''}`}>
          <div className="content">
            <div className="manual-scanner-sec">
              <div className="form-blk">
                <div className="fm-inner">
                  <div className="input-wrap">
                    <input
                      onFocus={() => {
                        this.props.setLoginType('email');
                        this.props.toggleKeyboard('email');
                      }}
                      ref={input => {
                        this.textInput = input;
                      }}
                      id="EmailInput"
                      type="text"
                      placeholder="Enter Email Address"
                      autoComplete="off"
                      value={this.props.email}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            </div>
            {this.props.email != '' && this.props.loginErrorMsg != '' && (
              <div className="error-blk">
                <p>{this.props.loginErrorMsg}</p>
              </div>
            )}
          </div>
          <p className="or-para">OR</p>
        </div>
        {this.state.showKeyboard ? (
          <Keyboard
            keyboardRef={r => (this.keyboard = r)}
            layoutName={this.props.activeKeyboard == 'phone' ? 'ip' : 'default'}
            onChange={input => this.emailChange(input)}
            onKeyPress={this.keyBoardOnKeyPress}
            layout={keyboardLayout}
            display={{
              '{bksp}': 'Backspace',
              '{phoneLoginCloseButton}': 'Close',
              '{enter}': 'Enter',
              '{shift}': 'Shift',
              '{tab}': 'Tab',
              '{lock}': 'CapsLock',
              '{space}': 'Space',
            }}
            disableRowButtonContainers={true}
            baseClass={'login-barcodescan-keyboard'}
            maxLength={50}
            buttonTheme={buttonTheme}
          />
        ) : null}
      </React.Fragment>
    );
  }
}
